import React, { useEffect, useMemo, useState } from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { isBrowser, isMobile } from 'react-device-detect';
import { Container, Row, Col } from 'reactstrap';

//store functions
import {
  setBusinessIndividualActiveStep,
  closeModal,
  setActiveLobbyTab,
  saveSelfCareBusinessIndividualBlockUrl,
  setViewWithoutPurchaseStatus,
  fetchPackageBusinessIndividualClient,
  setAllowedToAbroadLobby,
  saveToHistory,
  setLoading,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import { getContactCompanyList } from '../PortalsBlock/portalSlice';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { popupReasonEnum, businessIndividualSteps, lobbyTabsEnum, pages } from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import { gAPopupsLoadingReport } from './../CellcomAbroadLobbyBlock/gAPopupsLoadingReport';
import PopUp from '../../Shared/Popup/PopUp';
import SelectCompanyComponent from './SelectCompanyComponent';
import SelectAccountComponent from './SelectAccountComponent';
import OtpValidationResultPopupConstructor from '../../Block/CellcomAbroadLobbyBlock/Popups/OtpValidationResultPopupConstructor';
import PlaneLoader from '../AbroadTicketBlock/PlaneLoader';
import Config from '../../../Config';

const AbroadBusinessIndividualMain = (props) => {
  const allowedPopupsReasons = [popupReasonEnum.OTP_RESULT];
  const [allowedToLobby, setAllowedToLobby] = useState(false);
  useEffect(() => {
    props.setLoading(false);
    if (checkIfAllowed()) {
      props.setAllowedToAbroadLobby(false);
      props.saveSelfCareBusinessIndividualBlockUrl(props.viewContext.currentPath);
    } else {
      goToSelfCareLobby();
    }
  }, []);

  useEffect(() => {
    setAllowedToLobby(props.data.businessIndividualData.allowedToAbroadLobby);
  }, [props.data.businessIndividualData.allowedToAbroadLobby]);

  const checkIfAllowed = () => {
    return props.authentication?.loginData?.userDetails.IsContactPerson;
  };

  const goToSelfCareLobby = async () => {
    var content = await props.context.loadContentByPath(Config.businessLobbyUrl);
    props.context.navigateTo(content);
  };

  useEffect(() => {
    async function load() {
      await props.getContactCompanyList();
    }
    if (props.portalsBlock.hetPaysNumbers.length == 0 && !props.portalsBlock.requestCompleted && checkIfAllowed()) {
      load();
    } else if (props.data.businessIndividualActiveStep == businessIndividualSteps.LOADER) {
      props.setBusinessIndividualActiveStep(businessIndividualSteps.SELECT_COMPANY);
    }
  }, [props.portalsBlock.hetPaysNumbers]);

  useEffect(() => {
    if (props.data.businessIndividualData.isSelectingAccount) {
      props.setBusinessIndividualActiveStep(businessIndividualSteps.SELECT_ACCOUNT);
    }
  }, [props.data.businessIndividualData.isSelectingAccount]);

  //Popups Logic
  const currentPopup = useMemo(() => {
    if (props.data.isShowPopup && allowedPopupsReasons.includes(props.data.popupReason)) {
      gAPopupsLoadingReport({
        popupReason: props.data.popupReason,
        errorType: props.data.businessIndividualData.popupData.id,
        startedFromPackage: false,
        businessOrPrivate: 'Business',
        comingFromPackageManager: false,
        isFamilyProcess: false,
        isSeparatedSale: false,
        isBusinessIndividual: true,
        selectedPackage: props.data.selectedAbroadPackage,

      });
      return (
        <OtpValidationResultPopupConstructor
          popupData={props.data.businessIndividualData.popupData}
          context={props.context}
          lobbyPath={props.iContent.urlToAbroadLobbyBlock.value.url}
        />
      );
    }
  }, [props.data.isShowPopup, props.data.popupReason]);

  useEffect(() => {
    if (
      allowedToLobby &&
      props.data.businessIndividualData.selectedAccountNumber &&
      !props.data.isShowPopup &&
      !props.data.businessIndividualData.autoPackageExist &&
      props.portalsBlock.selectedHetPayAllowedToActions
    ) {
      const activeTab =
        props.data.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL
          ? lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL
          : lobbyTabsEnum.BUSINESSINDIVIDUAL;
      props.setActiveLobbyTab(activeTab);

      if (props.data.selectedAbroadPackage && props.data.page == pages.SALE) {
        props.context.navigateTo(props.data.epiStyleInitializationData.urlToSaleBlock);
      } else {
        if (
          props.data.selectedCountries?.length > 0 &&
          props.data.dates.datePickerStartJSFormat &&
          props.data.dates.datePickerEndJSFormat
        ) {
          goToAbroadLobby(false);
        } else {
          props.context.navigateTo(props.iContent.urlToAbroadLobbyBlock.value.url);
        }
      }
    }
  }, [props.data.businessIndividualData.selectedAccountNumber, props.data.isShowPopup, allowedToLobby]);

  const goToAbroadLobby = async (viewOnly) => {
    const orgId = props.portalsBlock.privateCompanyList.find((org) => org.idNumber == props.portalsBlock.selectedHetPay).orgId;
    let searchRequest = {
      OrgId: orgId,
      PhoneNumber: props.data.businessIndividualData.selectedAccountNumber ? props.data.businessIndividualData.selectedAccountNumber : null,
      BlockId: props.data.epiStyleInitializationData?.businessSocPackageFolderId
        ? props.data.epiStyleInitializationData.businessSocPackageFolderId
        : null,
      GoldBusinessPackagesBlockId: props.data.epiStyleInitializationData?.goldBusinessSocPackageFolderId
        ? props.data.epiStyleInitializationData.goldBusinessSocPackageFolderId
        : null,
    };
    await props
      .fetchPackageBusinessIndividualClient(searchRequest)
      .then((res) => {
        if (!res.payload.error) {
          props.setActiveLobbyTab(lobbyTabsEnum.BUSINESSINDIVIDUAL);
          props.setViewWithoutPurchaseStatus(viewOnly);
          props.context.navigateTo(props.iContent.urlToAbroadLobbyBlock.value.url);
        }
      })
      .catch(() => { })
      .finally(() => { });
  };

  const gaAndGoToBusinessLobby = async () => {
    var content = await props.context.loadContentByPath(Config.businessLobbyUrl);
    props.context.navigateTo(content);
  };

  //CURRENT STEP
  function renderStep(step) {
    switch (step) {
      case businessIndividualSteps.SELECT_COMPANY:
        return <SelectCompanyComponent gaAndGoToBusinessLobby={gaAndGoToBusinessLobby} />;
      case businessIndividualSteps.SELECT_ACCOUNT:
        return (
          <SelectAccountComponent
            context={props.context}
            urlToAbroadLobbyBlock={props.iContent.urlToAbroadLobbyBlock.value.url}
            goToAbroadLobby={(viewOnly) => goToAbroadLobby(viewOnly)}
          />
        );
      default:
        return null;
    }
  }

  const closeModal = () => {
    if (props.data.businessIndividualData.popupData?.id == 'autoPackageExistsBusinessIndividual') {
      props.setActiveLobbyTab(lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL);
    }
    props.closeModal();
  };

  return (
    <>
      {checkIfAllowed() && (
        <Container className={`${isMobile ? 'isMobile' : ''} abroad-business-individual-container `}>
          {props.data.generalLoader || props.data.searchIsLoading ? (
            <div className='loader-wrapper'>
              <PlaneLoader />
            </div>
          ) : null}
          {renderStep(props.data.businessIndividualActiveStep)}

          <PopUp
            className={props.data.popupReason}
            showPopUp={props.data.isShowPopup && allowedPopupsReasons.includes(props.data.popupReason)}
            onClose={() => closeModal()}>
            {currentPopup}
          </PopUp>
        </Container>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
    portalsBlock: state.portalsBlock,
    viewContext: state.ViewContext,
    authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  getContactCompanyList,
  setBusinessIndividualActiveStep,
  closeModal,
  setActiveLobbyTab,
  saveSelfCareBusinessIndividualBlockUrl,
  fetchPackageBusinessIndividualClient,
  setViewWithoutPurchaseStatus,
  showAppLoader,
  hideAppLoader,
  setAllowedToAbroadLobby,
  saveToHistory,
  setLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadBusinessIndividualMain);
